// var $rows_inner;
var $rows

// todo: for setRowsHeight, instead of window.innerHeight use different values that i created for iphones √
// todo: position elements before showing them?
// todo: test with cover?? √ cover is always 100vh and doesnt need to get bigger than that √

import { Utility, getTargetContainersExceptPageOverlay, getTargetContainers } from '../utility/utility_controller'

// this is for calculating rowcustomheight in px
var calcCustomRowHeight = function (rowcustomheight, _100vh_height, window_width) {
	// dispatch(actions.updateCustomCalculatedMaxRowsHeightAction())

	// vh replacen mit px
	// dann rechnung machen
	var arr = rowcustomheight.split(' ')
	var calculationArr = []
	for (var index = 0; index < arr.length; index++) {
		var element = arr[index]
		if (element.indexOf('vh') !== -1 || element.indexOf('lvh') !== -1 || element.indexOf('svh') !== -1) {
			element = element.replace('vh', '')
			element = element.replace('svh', '')
			element = element.replace('lvh', '')
			var num = parseFloat(element)
			// use my custom 100vh height
			num = (_100vh_height / 100) * num
			calculationArr.push(num)
		} else if (element.indexOf('vw') !== -1) {
			element = element.replace('vw', '')
			let num = parseFloat(element)
			// use my custom 100vw height
			num = (window_width / 100) * num
			calculationArr.push(num)
		} else if (element.indexOf('px') !== -1) {
			element = element.replace('px', '')
			var num = parseFloat(element)
			calculationArr.push(num)
		} else {
			// this is probably an operator like / * - +
			calculationArr.push(element)
		}
	}
	var mystr = calculationArr.join('')

	var mynumber = Math.round(looseJsonParse(mystr))

	return mynumber
}

// doing this because on mobile devices a 100vh height can be different (_100vh.scss)
// i get all css rules for 100vh rows
// then i see if any of them match my current row
// then i set the data-original-100vh-height attr to that rule
// this way i can always calculate the row height that is set in my css like "100vh - 109px" with "getOriginalRowHeight"
// to properly size my rows heights
// i need to set my rows heights because some position absolute elements might be taller than the row
var set100vh = function () {
	if (typeof $rows != 'undefined' && $rows.length > 0) {
		// https://developer.mozilla.org/en-US/docs/Web/API/StyleSheetList
		var i, styleSheet, styleSheets, styleSheetsNo
		styleSheets = document.styleSheets
		var frontendStyle = false
		for (i = 0; i < styleSheets.length; i++) {
			styleSheet = styleSheets[i]
			if (styleSheet.ownerNode != null && styleSheet.ownerNode.id == 'frontend-style-css') {
				frontendStyle = styleSheet
			}
		}
		// make it work when stylesheet is hosted on cdn
		// https://stackoverflow.com/questions/71327187/cannot-access-cssrules-for-stylesheet-cors/71327476#71327476
		styleSheet.crossOrigin = 'anonymous'

		// the following might not work due to css being hosted on a different platform
		// so we use try catch
		try {
			var _100vh_rules = []
			if (frontendStyle != false) {
				for (var i = 0; i < frontendStyle.cssRules.length; i++) {
					var rule = frontendStyle.cssRules[i]
					if (typeof rule.selectorText != 'undefined' && rule.selectorText.indexOf('_100vh') != -1) {
						// get all rules, see if 100vh elements match rules

						_100vh_rules.push(rule)
					}
				}

				// https://developer.mozilla.org/en-US/docs/Web/API/Element/matches

				// todo: does one selector override another causing it to use that css, but in my js i dont account for that? √ i think yes
				$rows.each(function () {
					var appliedMinHeightStyle = ''
					if (this.classList.contains('_100vh')) {
						var rowel = this
						for (i = 0; i < _100vh_rules.length; i++) {
							var rule = _100vh_rules[i]
							if (rowel.matches(rule.selectorText)) {
								appliedMinHeightStyle = rule.style.minHeight
							}
						}
						jQuery(this).attr('data-original-100vh-height', appliedMinHeightStyle)
					} else if (this.classList.contains('rowcustomheight')) {
						var rowel = this
						// because rowcustomheight does not match a ._100vh selector, we need to add _100vh class into a clone here
						var $clone = jQuery(rowel).clone()
						$clone[0].classList.add('_100vh')

						for (i = 0; i < _100vh_rules.length; i++) {
							var rule = _100vh_rules[i]
							if ($clone[0].matches(rule.selectorText)) {
								appliedMinHeightStyle = rule.style.minHeight
							}
						}

						jQuery(this).attr('data-original-100vh-height', appliedMinHeightStyle)

						var $el = jQuery(this).find('.row-inner.rowcustomheight')
						var css = $el.attr('style')
						// if there is no "calc(" then we already used the value to create 'data-original-rowcustomheight'
						// in this case dont do this bc we would use the calculated value as the original value
						if (typeof css != 'undefined' && css.indexOf('min-height:calc(') !== -1) {
							var rowcustomheight = css.replace('min-height:calc(', '')
							rowcustomheight = rowcustomheight.replace(');', '')

							jQuery(this).attr('data-original-rowcustomheight', rowcustomheight)
						}
					}
				})
			}
		} catch (error) {
			console.error(error)
		}
	}
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/eval#never_use_eval!
function looseJsonParse(obj) {
	return Function(`"use strict";return (${obj})`)()
}

var getOriginalRowHeight = function (el) {
	if (typeof $rows != 'undefined' && $rows.length > 0) {
		var min_height = jQuery(el).attr('data-original-100vh-height')
		if (typeof min_height != 'undefined') {
			if (min_height == '100vh' || min_height == '100lvh') {
				return window.innerHeight
			}
			// get calculated 100vh. which is for example 100vh - 109px
			if (min_height.indexOf('calc(') != -1) {
				var ix1 = min_height.indexOf('calc(')
				var ix2 = min_height.indexOf(')')
				var newstr = min_height.substring(ix1 + 5, ix2)

				newstr = newstr.replace('100vh', 'window.innerHeight')
				newstr = newstr.replace('100svh', 'window.innerHeight')
				newstr = newstr.replace('100lvh', 'window.innerHeight')

				newstr = newstr.replace('100vw', 'window.innerWidth')

				newstr = newstr.replace('px', '')
				var calculated = looseJsonParse(newstr)
				return calculated
			}
		}
		// console.error('no 100vh css rule found for this row! this should not happen')
		return window.innerHeight
	}
}

var doPositioning = function () {
	setRowsHeight()
	alignColumns()
}

var setRowsHeight = function () {
	if (typeof $rows != 'undefined' && $rows.length > 0) {
		// because many elements in 100vh rows are now position absolute, we need to resize 100vh rows in case an absolute-positioned element
		// is taller than the 100vh row, the row needs to become as tall as that element

		$rows.each(function () {
			if (jQuery(this).attr('data-collapsed') == 'false') {
				// Skip height calculations for rows containing thumbnailgrid or productsgrid

				if (this.classList.contains('_100vh')) {
					size100VhRowHeights(this)
				} else if (this.classList.contains('rowcustomheight')) {
					var h = getCustomRowHeight(this)
					// not every element is position absolute. so we just set a min-height instead of the height
					jQuery(this).css('min-height', h)
					jQuery(this).find('.rowcustomheight').css('min-height', h)
				}
			}
		})
		window.laytheme.emit('rows_height_set')
	}
}

var size100VhRowHeights = function (row) {
	// dont do it when fullscreen slider is enabled because this can fuck up the slider heights which are predefined by fs slider anyways :)
	if (jQuery('html').hasClass('fp-enabled')) {
		return
	}
	var originalRowHeight = getOriginalRowHeight(row)

	var tallestPosAbsoluteElementHeight = -1
	jQuery(row)
		.find('.col.absolute-position')
		.each(function () {
			var rect = this.getBoundingClientRect()
			if (rect.height > tallestPosAbsoluteElementHeight) {
				tallestPosAbsoluteElementHeight = rect.height
			}
		})
	if (tallestPosAbsoluteElementHeight !== -1 && originalRowHeight < tallestPosAbsoluteElementHeight) {
		jQuery(row).css('min-height', tallestPosAbsoluteElementHeight)
		jQuery(row).find('._100vh').css('min-height', tallestPosAbsoluteElementHeight)
	} else {
		jQuery(row).css('min-height', '')
		jQuery(row).find('._100vh').css('min-height', '')
	}
}

var getCustomRowHeight = function (row) {
	var _100vh_height = getOriginalRowHeight(row)
	// _100vh_height is just our current 100vh height
	// now we just need to calculate the rowcustom calc height

	// not every element is position absolute. so we just set a min-height instead of the height
	var rowcustomheight = jQuery(row).attr('data-original-rowcustomheight')
	var customRowHeightinPx = calcCustomRowHeight(rowcustomheight, _100vh_height, window.innerWidth)

	// seems that carousel needs some time to build and during this time its size is too big, so we dont use it for this calculation:
	var tallestPosAbsoluteElementHeight = -1
	jQuery(row)
		.find('.col.absolute-position:not(.type-carousel)')
		.each(function () {
			var rect = this.getBoundingClientRect()
			if (rect.height > tallestPosAbsoluteElementHeight) {
				tallestPosAbsoluteElementHeight = rect.height
			}
		})
	if (tallestPosAbsoluteElementHeight !== -1 && customRowHeightinPx < tallestPosAbsoluteElementHeight) {
		return tallestPosAbsoluteElementHeight
	} else {
		return rowcustomheight
	}
}

// see if aligning to one third or two thirds would go out of bounds
// if it wouldn't, then really align it by doing marginTop or marginBottom, otherwise it will stick to top or bottom
var alignColumns = function () {
	if (typeof $rows != 'undefined' && $rows.length > 0) {
		var doAlign = true
		// todo: put hasCPL in utility js?
		var hasCPL = jQuery('#custom-phone-grid').length != 0
		if (Utility.isPhoneSize && !hasCPL) {
			doAlign = false
		}

		if (doAlign) {
			// use .column-wrap> so we dont target columns inside of stack
			// if ($rows.find('.column-wrap>.col.align-onethird').length > 0) {
			// 	$rows.each(function () {
			// 		var $row = jQuery(this)
			// 		if ($row.find('.column-wrap>.col.align-onethird').length > 0) {
			// 			var rowRect = this.getBoundingClientRect()
			// 			var originalTop = rowRect.top
			// 			var top = originalTop
			// 			var rowRect = this.getBoundingClientRect()
			// 			$row.find('.column-wrap>.col.align-onethird').each(function () {
			// 				var $col = jQuery(this)
			// 				var elRect = this.getBoundingClientRect()
			// 				var elHeight = elRect.height
			// 				top += rowRect.height * (1 / 3) - elHeight / 2
			// 				// prevent from top overflow if element is too tall
			// 				var bottom = top + elHeight
			// 				if (top < originalTop || bottom > rowRect.bottom) {
			// 					$col.css('marginTop', '')
			// 				} else {
			// 					$col.css('marginTop', rowRect.height * (1 / 3) - elHeight / 2)
			// 				}
			// 			})
			// 		}
			// 	})
			// }
			// use .column-wrap> so we dont target columns inside of stack
			// if ($rows.find('.column-wrap>.col.align-twothirds').length > 0) {
			// 	$rows.each(function () {
			// 		var $row = jQuery(this)
			// 		if ($row.find('.column-wrap>.col.align-twothirds').length > 0) {
			// 			var rowRect = this.getBoundingClientRect()
			// 			$row.find('.column-wrap>.col.align-twothirds').each(function () {
			// 				var $col = jQuery(this)
			// 				var elRect = this.getBoundingClientRect()
			// 				var elHeight = elRect.height
			// 				var elMarginBottom = rowRect.height * (1 / 3) - elHeight / 2
			// 				var elTop = rowRect.bottom - elMarginBottom + elRect.height
			// 				var elBottom = rowRect.bottom - elMarginBottom
			// 				// prevent from bottom overflow if element is too tall
			// 				if (elTop < rowRect.top || elBottom > rowRect.bottom) {
			// 					$col.css('marginBottom', '')
			// 				} else {
			// 					$col.css('marginBottom', rowRect.height * (1 / 3) - elHeight / 2)
			// 				}
			// 			})
			// 		}
			// 	})
			// }
		} else {
			// for apl dont use margin-tops!
			// need to do it this way instead of: var hasCPL = jQuery('#custom-phone-grid').length != 0;
			// because of news full content style
			// $rows.each(function () {
			// 	if (jQuery(this).closest('#custom-phone-grid').length == 0) {
			// 		jQuery(this).find('.column-wrap>.col.align-onethird').css('marginTop', '')
			// 		jQuery(this).find('.column-wrap>.col.align-twothirds').css('marginBottom', '')
			// 	}
			// })
		}
	}
}

var bindOnContentReady = function () {
	window.laytheme.on('content_ready', function (typeOfContentThatIsReady) {
		// $rows_inner = undefined;
		$rows = undefined
		var $target
		$target = getTargetContainersExceptPageOverlay(typeOfContentThatIsReady)
		$rows = $target.find('.row')

		set100vh()
		doPositioning()
		// lets just do it again after one second in case there are elements that changed in height :D
		// like a shortcode element or when navigation dots are appended to a carousel
		setTimeout(function () {
			doPositioning()
		}, 1000)
	})
}

var bindPageOverlayShown = function () {
	window.laytheme.on('overlayshown', function () {
		var typeOfContentThatIsReady = Utility.screenSize
		if (Utility.screenSize == 'tablet') {
			typeOfContentThatIsReady = 'desktop'
		}

		$rows = undefined
		var $target
		$target = getTargetContainers(typeOfContentThatIsReady)
		$rows = $target.find('.row')

		set100vh()
		doPositioning()
		// lets just do it again after one second in case there are elements that changed in height :D
		// like a shortcode element or when navigation dots are appended to a carousel
		setTimeout(function () {
			doPositioning()
		}, 1000)
	})
}

var i = function () {
	if (Utility.isTouchDevice === true) {
		window.laytheme.on('sizechanged', function () {
			set100vh()
		})
		jQuery(window).on('window_width_changed orientationchange', function () {
			doPositioning
		})
	} else {
		window.laytheme.on('sizechanged', function () {
			set100vh()
		})
		jQuery(window).on('resize', doPositioning)
	}
	// size changed between phone, tablet, desktop, re-init layouts
	// window.laytheme.on('sizechanged', onResize);
	bindOnContentReady()
	bindPageOverlayShown()
}

var positioning = {
	i: i,
	doPositioning: doPositioning,
}

export default positioning
